import {brandOrm} from '@/utils/orm-tools/brand'
import {productOrm} from '@/utils/orm-tools/product'

export const getNextPublicId = (prefix: 'TM' | 'LS', lastPublicId: string): string => {
  const normalizedPrefix = prefix.concat('-')
  const normalizedId = lastPublicId.replace(normalizedPrefix, '')
  const idNumber = parseInt(normalizedId, 16)

  return normalizedPrefix.concat((idNumber + 1).toString(16).padStart(6, '0').toUpperCase())
}

export const getInvoiceOwnerIdByProductId = async (id: string): Promise<string | null> => {
  const product = await productOrm.getById(id)
  if (product.registration_request) {
    return product.registration_request.user_id
  }

  if (product.service_request) {
    return product.service_request.user_id
  }

  if (product.brand_subscription_payment) {
    const brand = await brandOrm.getMany({
      brand_subscriptions: {
        brand_subscription_payments: {id: {_eq: product.brand_subscription_payment.id}},
      },
    })

    return brand[0]?.user_id
  }

  return null
}
